import { apiService } from '@/services/Api'
import { ApplicationsStore } from '@/store/Applications'
import { authStore } from '@/store/Auth'
import { DictionaryStore } from '@/store/Dictionary'
import { MessageStore } from '@/store/Message'
import { mktuClassesList } from '@/store/Mktu/MktuClassesList'
import { NavigationStore } from '@/store/Navigation'
import { NotificationStore } from '@/store/Notification'
import { popupStore } from '@/store/Popup'
import { ServerOptionsStore } from '@/store/ServerOptions'
import { tokenStorage } from '@/store/TokenStorage'
import { userStore } from '@/store/User'
import { makeAutoObservable, reaction } from 'mobx'

class MainStore {
  popup = popupStore

  user = userStore

  message = new MessageStore()

  auth = authStore

  dictionary = new DictionaryStore()

  notifications = new NotificationStore()

  navigation = new NavigationStore()

  serverOptions = new ServerOptionsStore()

  applications = new ApplicationsStore()

  mktuClassesList = mktuClassesList

  constructor() {
    makeAutoObservable(this)

    reaction(
      () => this.user.uuid,
      (value) => {
        if (value != null) {
          this.serverOptions.get()
          this.navigation.getCounts()
          this.notifications.loaderList.request()
        }
      }
    )
  }

  logout() {
    apiService.user.logout().then(() => {
      this.clearOnLogout()
    })
  }

  clearOnLogout() {
    tokenStorage.clearTokens()
    this.notifications.setList([])
    this.user.reset()
    this.auth.setLoadingPage(false)
    this.applications.setList([])
  }
}

export const mainStore = new MainStore()
